import { Modal, Spin } from "antd";
import { Assets } from "utils/Assets";
import UniversalDetail from "pages/universals/UniversalDetail";
import NoDataPage from "pages/nodata/NoDataPage";

const UniversalDetailModal = ({ openModal, setOpenModal, universalDetail, diagramData, loading }) => {
    return (
        <>
            <Modal
                footer=''
                width={1200}
                open={openModal}
                onCancel={() => { setOpenModal(false) }}
                closeIcon={<img src={Assets.closeIcon} alt="" />}
                className="modal_content"
                key={universalDetail}
            >
                <div className="mt-4">
                    {universalDetail ?
                        <Spin spinning={loading}>
                            <UniversalDetail universal={universalDetail} diagramData={diagramData} />
                        </Spin>
                        :
                        <NoDataPage img={Assets.darkLogo} />
                    }
                </div>
            </Modal>
        </>
    )
}

export default UniversalDetailModal;
